// api methods enum
export enum LockerStatuses {
  FULL = 'FULL',
  EMPTY = 'EMPTY',
  RESERVED = 'RESERVED',
}
